import { Injectable } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ModalDialogComponent } from '../components/modal-dialog/modal-dialog.component';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { LocalStorageService } from './local-storage.service';
import { Subscription, Observable, of } from 'rxjs';
import moment from 'moment';

@Injectable({ providedIn: 'root' })
export class GemsDialogService {
  bsModalRef: BsModalRef;
  subscriptions: Subscription[] = [];

  constructor(private bsModalService: BsModalService) { }

  showDialog(initialState: any, size: string = 'modal-md'): Observable<any> {
    const ignoreBackdropClick = true;
    if (initialState.showNeverAskMeAgainOption && LocalStorageService.fetch('Never-Show-' + initialState.dialogType)) {
      const data = JSON.parse(LocalStorageService.fetch('Never-Show-' + initialState.dialogType));
      const start = moment(data.date);
      const end = moment(Date.now());
      if (end.diff(start, 'days') >= 30) {
        this.bsModalRef = this.bsModalService.show(ModalDialogComponent, {
          initialState,
          ignoreBackdropClick,
          class: size
        });
        LocalStorageService.remove('Never-Show-' + initialState.dialogType);
      } else {
        return of(null);
      }
    } else {
      this.bsModalRef = this.bsModalService.show(ModalDialogComponent, {
        initialState,
        ignoreBackdropClick,
        class: size
      });
    }

    return this.bsModalService.onHide;
  }

  hide() {
    this.bsModalRef.hide();
  }
}
